<section class="carousel-wrapper" >
    <ul class="carousel-inner" #carousel [ngStyle]="carouselWrapperStyle">
        <li *ngFor="let item of items" class="carousel-item" [ngStyle]="carouselItemStyle">
            <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
        </li>
    </ul>
</section>
<ng-container *ngIf="showControls">
    <button mat-icon-button class="carousel__prev-button" (click)="prev()">
        <mat-icon>chevron_left</mat-icon>
    </button>
    <button mat-icon-button class="carousel__next-button" (click)="next()">
        <mat-icon>chevron_right</mat-icon>
    </button>
</ng-container>
